// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b03a2d32","513":"8a505812","703":"7ca3c8b6"}[chunkId] + ".chunk.js";
};